import * as types from './mutationType'
import i18n from '@/config/i18n'

export const mutations = {
  handler: () => {},
  // NOTE: Set and Change Languages
  [types.SET_LANG] (state: any, lang: string) {
    i18n.locale = lang
    state.lang = lang
  },

  // NOTE: Set Login State
  [types.SET_IS_LOGIN] (state: any, payload: boolean) {
    state.isLogin = payload
  },
  [types.SET_LOGINED_BY] (state: any, payload: string) {
    state.loginedBy = payload
  },
  [types.DELETE_LOGINED_BY] (state: any) {
    state.loginedBy = ''
  },

  // NOTE: Set Loading State
  [types.ADD_LOADING_STATE] (state: any, payload: string) {
    state.loadingStack = [...state.loadingStack, payload]
  },
  [types.DELETE_LOADING_STATE] (state: any, payload: string) {
    state.loadingStack = state.loadingStack.filter((t: any) => t !== payload)
  },

  // NOTE: Set Toast
  [types.ADD_TOASTS_DATA] (state: any, payload: any) {
    state.toastStack = [...state.toastStack, payload].map((obj: any, i: number) => Object.assign(obj, { index: i }))
  },
  [types.DELETE_TOASTS_DATA] (state: any, index: number) {
    state.toastStack = state.toastStack.filter((t: any) => t.index !== index).map((obj: any, i: number) => Object.assign(obj, { index: i }))
  },
  [types.COUNT_DOWN_TOASTS_TIME] (state: any, index: number) {
    state.toastStack[index].countDown = true
  },

  // NOTE: Set Time zone
  [types.SET_TIME_ZONE] (state: any, timezone: string) {
    state.timezone = timezone
  },
}
